import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import appContext from 'features/common/appContext';

export const ResolveCompany = ({ companyId, showOnlyTo, children }) => {
	if (companyId !== showOnlyTo) {
		return null;
	} else {
		return children;
	}
};

ResolveCompany.displayName = 'ResolveCompany';

const mapStateToProps = (state) => ({
	companyId: appContext.selectors.getCompanyId(state),
});

ResolveCompany.propTypes = {
	children: PropTypes.any,
	companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	showOnlyTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default connect(mapStateToProps)(ResolveCompany);
